import React from 'react';
import '../styles/Resume.css';


const Resume = () => {
  return (
    <div className="resume-container">
      <header className="resume-header">
        <h1>Joanne Lin</h1>
        <p>(917) 767-1698 | joannelinmusic@gmail.com | linkedin.com/in/joannelinmusic/</p>
      </header>

      <div className="resume-sections">
        <Section title="Education" content={educationContent} />
        <Section title="Experience" content={experienceContent} />
        <Section title="Projects" content={projectsContent} />
        <Section title="Skills" content={skillsContent} />
      </div>
    </div>
  );
};

const Section = ({ title, content }) => {
  return (
    <div className="resume-section">
      <h2>{title}</h2>
      <div className="section-content">
        {content.map((item, index) => (
          <div className="section-card" key={index}>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

// Sample data for each section
const educationContent = [
  { title: 'DePaul University', description: 'B.S. in Data Science / B.M. in Violin Performance (GPA 3.88/4.00)' },
  { title: 'The Juilliard School', description: 'Violin Performance Major in Pre-College Division' },
];

const experienceContent = [
  { title: 'Federated Hermes', description: 'Data Scientist Intern (Jun 2024 – Aug 2024)' },
  { title: 'Eugene P. Jarvis College of Computing', description: 'Lead Research Assistant (Jun 2023 – May 2024)' },
];

const projectsContent = [
  { title: 'Flock - Ultimate Safety App', description: 'Developed a mobile app addressing safety concerns for students.' },
  { title: 'TW Foodiemon', description: 'Used Django to create a UI featuring food-based Pokémon characters.' },
];

const skillsContent = [
  { title: 'Programming Languages', description: 'Python, R, SQL' },
  { title: 'Frameworks and Libraries', description: 'PyTorch, TensorFlow, Django' },
  { title: 'Technical Tools', description: 'Azure, Databricks, Power BI' },
];

export default Resume;
